import bee from "./Bee";
export default {
    name: "ContactUs",
    /*
        var query = {
            first_name: "",
            last_name: "",
            email: "",
            phone_number: "",
            message: ""
        }
    */
    /* eslint-disable no-unused-vars */
    send_message(query, success, fail) {
        bee.post({
            contact_us_message: {
                ...query,
                is_read: 0,
                is_read_by_id: 0,
                read_on: "1989-01-01",
                _time_read_on_timestamp: "1989-01-01"
            }
        })
            .then(res => {
                if (success) {
                    success(res.contact_us_message);
                    //nyd
                    //tell the admin that you have a new message on contact us
                    //both via sms and email address
                }
            })
            .catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    /* eslint-disable no-unused-vars */
    get_contact_messages(query, success, fail) {
        bee.get(
            {
                contact_us_messages: {
                    _a: "id email message is_read time_inserted",
                    _desc: ["id"]
                }
            }
        ).then(res => {
            if (success) {
                success(res.contact_us_messages);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        })
    },
    /*
        query = {
            id: 4
        }
    */
    /* eslint-disable no-unused-vars */
    get_contact_message(query, success, fail) {
        bee.get(
            {
                contact_us_message: {
                    _a: "id first_name last_name email phone_number message is_read is_read_by_id read_on read_on_timestamp time_inserted",
                    _w: [
                        ["id", "e", query.id]
                    ]
                }
            }
        ).then(res => {
            if (success) {
                success(res.contact_us_message);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        })
    },
    /*
        query = {
            id: 4
        }
    */
    /* eslint-disable no-unused-vars */
    update_contact_message(query, success, fail) {
        var up = {
            contact_us_message: {
                ...query,
                _w: [
                    ["id", "e", query.id]
                ]
            },
            // _sql:{}
        };
        delete up.contact_us_message.id;
        bee.update(up).then(res => {
            if (success) {
                success(res.contact_us_message);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        })
    },
}